import StoreName    from '../../Shared/Constants/StoreName';
import IPlayerState from '../../Shared/Interfaces/IPlayerState';

import ITimeline              from './Interfaces/ITimeline';
import ITimelineStore         from './Interfaces/ITimelineStore';
import resolveTimelineActions from './resolveTimelineActions';
import Timeline               from './Timeline';

const createTimelineStore = (
    state: IPlayerState,
    initialValue?: ITimeline
): ITimelineStore =>
    state.createStore({
        name: StoreName.TIMELINE,
        model: Timeline,
        actions: resolveTimelineActions
    }, initialValue);

export default createTimelineStore;
